export const SET_CHILDREN_DETAIL = 'SET_CHILDREN_DETAIL';
export const CLEAR_CHILDREN_DETAIL = 'CLEAR_CHILDREN_DETAIL';
export const SET_LIST_VIDEO = 'SET_LIST_VIDEO';
export const SET_LIST_DATES_HAS_VIDEO = 'SET_LIST_DATES_HAS_VIDEO';
export const SET_LIST_DATES_HAS_EVALUATION = 'SET_LIST_DATES_HAS_EVALUATION';
export const SET_CREATE_REPORT_DATA = 'SET_CREATE_REPORT_DATA';
